import { create } from "zustand"

const BASE_TITLE = "CruisingPower | Travel Professional Portal"

interface PageTitleState {
	title: string | null
	setTitle: (title: string | null) => void
	clearTitle: () => void
	getFullTitle: () => string
}

export const usePageTitleStore = create<PageTitleState>((set, get) => ({
	title: null,

	setTitle: (title: string | null) => {
		set({ title })
		// Update document title immediately
		const fullTitle = title ? `${title} | ${BASE_TITLE}` : BASE_TITLE
		document.title = fullTitle
	},

	clearTitle: () => {
		set({ title: null })
		document.title = BASE_TITLE
	},

	getFullTitle: () => {
		const { title } = get()
		return title ? `${title} | ${BASE_TITLE}` : BASE_TITLE
	}
}))
